import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
TimeAgo.addDefaultLocale(en)

export { default as Age } from './Age';
export { default as Date } from './Date';
export { default as Money } from './Money';